import { ColorEnum } from '@/constants/color'
import { PrintType } from '@/features/print/constants'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'

interface PrintTypesProps {
    printTypes: PrintType[]
}

const PrintTypes: FC<PrintTypesProps> = ({ printTypes }) => {
    const { t } = useTranslation()

    return (
        <Typography.Description style={styles.description}>
            {printTypes.map((printType) => t(`printTypes.${printType}`, printType)).join(', ')}
        </Typography.Description>
    )
}

const styles = StyleSheet.create({
    description: {
        color: ColorEnum.GRAY_600,
    },
})

export default PrintTypes
